import React from 'react';
import { BatteryWarning, HelpCircle, Frown } from 'lucide-react';
import { Section } from './Shared';
export function PainSection() {
  return <div className="bg-cream-dark border-y border-beige-muted/50" data-id="element-139">
      <Section className="max-w-4xl" data-id="element-140">
        <div className="grid gap-6 md:grid-cols-3" data-id="element-141">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/30 flex flex-col items-center text-center" data-id="element-142">
            <div className="bg-sage-light/30 p-4 rounded-full mb-6" data-id="element-143">
              <BatteryWarning className="w-8 h-8 text-sage-dark" data-id="element-144" />
            </div>
            <p className="text-charcoal text-lg font-medium" data-id="element-145">
              Dormís mal hace meses y sentís que ya no podés más
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/30 flex flex-col items-center text-center" data-id="element-146">
            <div className="bg-sage-light/30 p-4 rounded-full mb-6" data-id="element-147">
              <HelpCircle className="w-8 h-8 text-sage-dark" data-id="element-148" />
            </div>
            <p className="text-charcoal text-lg font-medium" data-id="element-149">
              Probaste de todo… y nada funciona más de 2 noches seguidas
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/30 flex flex-col items-center text-center" data-id="element-150">
            <div className="bg-sage-light/30 p-4 rounded-full mb-6" data-id="element-151">
              <Frown className="w-8 h-8 text-sage-dark" data-id="element-152" />
            </div>
            <p className="text-charcoal text-lg font-medium" data-id="element-153">
              Sentís culpa, frustración y no sabés qué más hacer
            </p>
          </div>
        </div>
      </Section>
    </div>;
}